import React from "react";
import { NavLink } from "react-router-dom";
import "./OffhireReportsHeader.css";

const OffhireReportsHeader = ({ title, children }) => {
  return (
    <div className="card-header offhire-reports-header">
      <div className="offhire-reports-header__inner">
        <div className="offhire-reports-header__left">
          <div className="offhire-reports-header__title">{title}</div>
          <div className="offhire-reports-header__tabs">
            <NavLink
              to={"/offhire/reports"}
              end
              className={({ isActive }) =>
                `offhire-reports-header__tab${isActive ? " active" : ""}`
              }
            >
              Reports
            </NavLink>
            <NavLink
              to={"/offhire/reports/removed"}
              className={({ isActive }) =>
                `offhire-reports-header__tab${isActive ? " active" : ""}`
              }
            >
              Removed Reports
            </NavLink>
          </div>
        </div>
        <div className="offhire-reports-header__right">{children}</div>
      </div>
    </div>
  );
};

export default OffhireReportsHeader;
